import React from 'react';
import { useSelector } from 'react-redux';
import { selectSiteTokenDetails } from '../../../../../../../common/redux/features/playground/selectors';
import { CopyCode } from '../../../../../PageElements/CopyCode';
import { Text } from '../../../../../PageElements/Text';
import { EXAMPLE_TYPES } from '../../../../types';
import { injectToken } from '../../../../exampleTransformations';
import style from './exampleTitle.scss';

interface ExampleTitleProps {
  displayName: string;
  example: any;
  renderFor: EXAMPLE_TYPES;
}

export const ExampleTitle = ({
  displayName,
  example,
  renderFor,
}: ExampleTitleProps) => {
  const selectedSiteTokenDetails = useSelector(selectSiteTokenDetails);

  // response is always of type json
  const type = renderFor !== EXAMPLE_TYPES.RESPONSE ? example.type : 'json';

  const shouldRenderCopyButton =
    renderFor === EXAMPLE_TYPES.REQUEST ||
    renderFor === EXAMPLE_TYPES.JS_FUNCTION;

  const isJsType = renderFor === EXAMPLE_TYPES.JS_FUNCTION;

  const code = example.body;

  const codeWithToken = injectToken(
    code.join('\r\n'),
    selectedSiteTokenDetails.token || '',
  );

  return (
    <div
      className={`${style.titleContainer} ${
        isJsType && style.jsTitleContainer
      }`}
    >
      <div className={style.title}>
        <Text
          size="tiny"
          weight="normal"
          light
          dataHook={`${displayName}-example-title`}
        >
          {getTitle()}
        </Text>
        {type && (
          <Text
            size="tiny"
            weight="normal"
            light
            dataHook={`${displayName}-example-type`}
            className={style.language}
          >
            {type}
          </Text>
        )}
      </div>
      {shouldRenderCopyButton && (
        <>
          {type && <div className={style.border} />}
          <div className={`${isJsType && style.copyCode}`}>
            <CopyCode
              dataHook={`${displayName}-example-copy-button`}
              code={codeWithToken}
              light
            />
          </div>
        </>
      )}
    </div>
  );

  function getTitle() {
    switch (renderFor) {
      case EXAMPLE_TYPES.OBJECT:
        return `Object`;
      case EXAMPLE_TYPES.REQUEST:
        return 'Request';
      case EXAMPLE_TYPES.RESPONSE:
        return 'Response';
      case EXAMPLE_TYPES.WEBHOOKS:
        return 'Sample Data';
      case EXAMPLE_TYPES.WEBHOOKS_INTRO:
        return 'Event Body';
      default:
        return '';
    }
  }
};
